import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useQuery } from "@tanstack/vue-query";
import { getByIdMercuryTransactionsQuery } from "@vendata/power-up-sdk/requests/mercury-transactions/get-by-id";
import { listOrganizationsQuery } from "@vendata/power-up-sdk/requests/organizations/list";
import { listPartsQuery } from "@vendata/power-up-sdk/requests/parts/list";
import { listRepairsQuery } from "@vendata/power-up-sdk/requests/repairs/list";

export function useTransactionDetailLoader() {
  const route = useRoute();
  const id = computed(() => String(route.params.id ?? ""));
  const repairsLimit = ref(1000);

  return {
    transactionQuery: useQuery(getByIdMercuryTransactionsQuery({ id })),
    organizationsQuery: useQuery(listOrganizationsQuery()),
    partsQuery: useQuery(listPartsQuery({})),
    repairsQuery: useQuery(listRepairsQuery({ limit: repairsLimit })),
  };
}
